import get from "lodash/get";
import React from "react";
import { getStoryElementByType, getStoryElementsByType } from "../../../utils";
import "./note.m.css";

export const Note = ({ card }) => {
  const title = get(getStoryElementByType(card, "title"), ["text"], "");
  const textElements = getStoryElementsByType(card, "text");
  const description = get(textElements, "[0].text", "");
  const id = get(card, ["metadata", "attributes", "menuname", "0"], "");
  return (
    <div styleName="note-container" data-model-id="13968:54429" id={`${id.toLowerCase()}`}>
      <div styleName="event-details">
        <div styleName="event-title" dangerouslySetInnerHTML={{ __html: title }} />

        <div styleName="text-wrapper" dangerouslySetInnerHTML={{ __html: description }} />
      </div>
    </div>
  );
};
